export enum FoiEventType {
  NewEvent = 35,
  EventCompleted = 36
}
